
import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  const scrollToWarteliste = () => {
    const element = document.getElementById('warteliste');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/edc80bd8f380fb94b40cacabc0244b80.jpg')`
      }}
    >
      <div className="container mx-auto px-6 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Digitalisierung für Ihr Unternehmen
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
            Wir begleiten Sie dabei, Prozesse zu digitalisieren, Effizienz zu steigern und bessere Kundenerlebnisse zu schaffen. Mit über 35 Jahren Erfahrung und mehr als 20.000 Kunden.
          </p>
          
          <div className="bg-yellow-400 text-black px-6 py-4 rounded-lg mb-8 inline-block">
            <p className="text-lg font-semibold">
              🚀 Academy Start: Januar 2026 - Nur noch 40 Plätze verfügbar!
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              onClick={scrollToWarteliste}
              variant="primary"
              size="lg"
              className="bg-blue-600 hover:bg-blue-700"
            >
              Jetzt Warteliste beitreten
            </Button>
            <Button 
              onClick={() => {
                const element = document.getElementById('academy');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              variant="outline"
              size="lg"
              className="border-white text-white hover:bg-white hover:text-gray-900"
            >
              Mehr erfahren
            </Button>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-3xl font-bold text-yellow-400 mb-2">35+</div>
              <div className="text-sm">Jahre Erfahrung</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-3xl font-bold text-yellow-400 mb-2">20.000+</div>
              <div className="text-sm">Zufriedene Kunden</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-3xl font-bold text-yellow-400 mb-2">7%</div>
              <div className="text-sm">Kostenersparnis in 90 Tagen</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
